<template>
  <div>
    <div v-if="dataLoaded" class="loginWrapper">
      <div class="sliderLogin containerSingleBox">
        <!--Login box -->
        <div class="loginBox background-white">

          <div :class="['wrapper-login-companies']">
            <form v-if="
              !userCreateSuccess &&
              this.userCreate.flow !== 'add_role_customer'
            " @submit.prevent="addUserForCompany()">
              <table width="95%" align="center" cellpadding="10" cellspacing="0">
                <tr style="border-bottom: 1px solid #DEDEDE">
                  <td align="left" colspan="2">
                    <h2>{{ $t("createAccountTitle") }}</h2>
                  </td>
                  <!-- <td align="left">
                    <small>{{ $t("createAccountAlready") }}</small>
                    <a @click="redirectToLogin()" >
                      {{ $t("createAccountLogin") }}
                    </a>
                  </td> -->
                </tr>
                <tr>
                  <td align="left">
                    <small>{{ $t("lastNameLabel") }}</small>
                    <br />
                    <input type="text" required v-model="formData.last_name" class="formedituser" />
                  </td>
                  <td align="left">
                    <small>{{ $t("firstNameLabel") }}</small>
                    <br />
                    <input type="text" v-model="formData.first_name" class="formedituser" />
                  </td>
                </tr>
                <tr>
                  <td align="left" >
                    <small>{{ $t("emailLabel") }}</small>
                    <br />
                    <input type="text" v-model="formData.email" disabled class="formedituser" />
                  </td>
                  <td align="left" width="50%">
                    <small>{{ $t("cityLabel") }}</small>
                    <br />
                    <multiselect
                              v-model="formData.city"
                              :options="cities"
                              class="margin-top-1rem"
                              :placeholder="$t('selectLabel')"
                              select-label=""
                              selected-label=""
                              deselect-label=""
                            />

                  </td>
                </tr>
                <tr>
                  <td align="left">
                    <small>{{ $t("passwordField") }}</small>
                    <br />
                    <input type="password" required v-model="newPassword" @input="validatePassword"
                      class="formedituser" />
                  </td>
                  <td align="left">
                    <small>{{ $t("confirmPasswordField") }}</small>
                    <br />
                    <input type="password" required :style="confirmPasswordStyle" @input="validatePassword"
                      v-model="confirmPassword" class="formedituser" />
                  </td>
                </tr>
                <tr>
                  <td align="left">
                    <small>{{ $t("companyLabel") }}</small>
                    <br />
                    <input type="text" disabled v-model="userCreate.company_name" class="formedituser" />
                  </td>
                  <td align="left">
                    <small>{{ $t("roleCompanyLabel") }}</small>
                    <br />
                    <input type="text" v-model="formData.function" class="formedituser" maxlength="64" />

                    <!-- <select v-model="formData.company_role_id" class="w-100">
                      <option v-for="(entry, index) in functions" :key="index" :value="entry.code">
                        {{ entry.name }}
                      </option>
                    </select> -->
                    <!-- <input type="text" required v-model="formData.company_role_id" class="formedituser" /> -->
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <div style="    padding-left: 1.25rem;">
                      <input type="checkbox"  v-model="terms" class="form-check-input"  required />
                    </div>

                    <div class="form-check">
                      <label for="terms">
                        <a @click="showModalPopup('modal_popup_terms', true)" href="#">{{
                          $t("textReadAndAgree") + " " + $t("termsAndConditionsName")
                        }}</a>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td align="left">
                    <input type="submit" :value="[[$t('confirmButtonLabel')]]" variant="primary"
                      class="submitCompanies" />
                  </td>
                  <td align="left">
                    <small>{{ $t("createAccountAlready") }}</small>
                    <a @click="redirectToLogin()" class="pointer">
                      {{ $t("createAccountLogin") }}
                    </a>
                  </td>
                </tr>

                <!-- <p>
                  <password v-model="newPassword" :strength-meter-only="true" />
                </p> -->
              </table>
            </form>
            <form v-if="userCreateSuccess" @submit.prevent="redirectToLogin()" align="center">

              <h2 class="pt-3" align="center">
                {{ $t("successMessageTitle") }}
              </h2>
              <p v-if="userCreateSuccess" align="center" class="lightGrey">
                {{ $t("addUserSuccessMessage") }}
              </p>
              <input type="submit" :value="[[$t('finishButtonLabel')]]" class="submitCompanies"
                :class="'mandate-button'" />
            </form>
          </div>
        </div>
      </div>
      <!--End Login box -->
      <div id="modal_popup_terms" class="modal-popup">
        <div class="modal-popup-content">
          <a @click="showModalPopup('modal_popup_terms', false)" href="#" class="close-button">
            <img src="@/assets/images/close-button.svg" />
          </a>
          <p>
            <iframe :src="config.terms"></iframe>
            <br />
            <a class="button-all button-orange" @click="acceptAndClose()">{{
              $t("termsAcceptButton")
            }}</a>
          </p>
        </div>
      </div>
    </div>
    <div id="modal_popup_info" class="modal-popup">
      <div class="modal-popup-content">
        <a @click="showModalPopup('modal_popup_info', false)" class="close-button">
          <img src="@/assets/images/close-button.svg" />
        </a>
        <div v-if="this.userCreateError != null">
          <p>{{ $t('error_' + this.userCreateError.code) }}</p>
        </div>
      </div>
    </div>
    <!-- <modal-loading /> -->
  </div>
</template>

<script>
import utils from "@/plugins/utils.js";
import httpServiceUser from "@/http/http-user.js";
import httpServiceCommon from "@/http/http-common.js";
import validator from "@/plugins/fieldValidation";
// import ModalLoading from '@/components/fragments/ModalLoading.vue';
import cities from "@/assets/json/orase.js";


export default {
  name: "create_user_company",
  props: {},
  // components: {
    // ModalLoading
  // },
  data() {
    return {
      uuid: null,
      userCreate: null,
      userCreateError: null,
      userCreateSuccess: false,
      showPasswordForm: false,
      formData: {
        first_name: "",
        last_name: "",
        email: "",
        company_role_id: "",
        cityt: ""
      },
      terms: false,

      token: null,
      config: JSON.parse(sessionStorage.getItem("club_jsonFile")),
      dataLoaded: false,
      isIE: null,
      newPassword: null,
      confirmPassword: "",
      validPassword: {
        passwordValid: false,
        passwordLengthValid: false,
        containsLetter: false,
        containsNumber: false,
        confirmPasswordValid: false
      },
      functions: [{
        code: 4,
        name: "Sales manager"
      }],
      cities: cities,
    };
  },
  methods: {
    addUserForCompany() {

      if (
        !this.terms ||
        this.terms === false
      ) {
        this.userCreateError = {
          code: "TERMS",
        };
        this.showModalPopup("modal_popup_info", true);
        return;
      }
      if (!this.validPassword.passwordValid) {
        this.userCreateError = {
          code: "BPIP",
        };
        console.log(this.userCreateError);

        this.showModalPopup("modal_popup_info", true);
        return;
      }
      if (
        (this.newPassword === null || this.confirmPassword === "")
        ) {
          this.userCreateError = { code: 'BPIP' };
          
          this.showModalPopup("modal_popup_info", true);
          return;
        }
        
        this.userCreateSuccess = false;
      // this.showModalPopup("modal_popup_loading", true);

      this.userCreate.login.first_name = this.formData.first_name;
      this.userCreate.login.last_name = this.formData.last_name;
      this.userCreate.login.email = this.formData.username;
      this.userCreate.login.password = this.newPassword;
      this.userCreate.company_role = this.formData.company_role;
      this.userCreate.login.identification = this.formData.city;

      httpServiceUser.userService
        .confirmNewUserForManageCompany(
          this.userCreate.id,
          this.userCreate,
          this.token
        )
        .then(response => {
          if (response.status == 200 || response.status == 204) {
            this.userCreateSuccess = true;
            this.userCreateError = null;
            // this.showModalPopup("modal_popup_loading", false);
          } else {
            this.userCreateError = {
              code: response.data.error_code,
            };
            // this.showModalPopup("modal_popup_loading", false);
          }
        })
        .catch(error => {
          if (error.response) {
            this.userCreateError = {
              code: error.response.data.error_code,
            };
          } else {
            this.userCreateError = { code: error.response.status };
          }
          // this.showModalPopup("modal_popup_loading", false);
        });
    },
    getUserForCompany() {
      let uuidLink = "?uuid=" + this.uuid;
      this.userCreateError = null;

      // this.showModalPopup("modal_popup_loading", true);

      httpServiceUser.userService
        .getUserForCompany(uuidLink, this.token)
        .then(function (response) {
          return response;
        }).catch(error => {
          return error.response;
        }).then(response => {
          if (response.status === 200) {
            this.userCreate = response.data;
            this.formData = {
              first_name: this.userCreate.login.first_name,
              last_name: this.userCreate.login.last_name,
              email: this.userCreate.login.email,
              mobile_phone: "",
              city: ""
            };
            this.dataLoaded = true;
          } else {
            this.userCreateError = {
              code: response.status === 500 ? response.status : response.data.error_code,
              // description: this.getErrorMessage(response.data.error_code)
            };
            this.showModalPopup("modal_popup_info", true);
          }
          // this.showModalPopup("modal_popup_loading", false);
        })

    },
    acceptAndClose(){
      this.terms = true;
      this.showModalPopup('modal_popup_terms', false)
    },
    getTokenForValidateCredentials() {
      httpServiceCommon.companyService
        .requestTokenForRegistration("clientopen")
        .then(function (response) {
          // handle success
          return response.data;
        })
        .then(data => {
          this.token = data.access_token;
          this.getUserForCompany();
        })
        .catch(error => {
          // handle error
        });
    },
    redirectToLogin() {
      this.showModalPopup("modal_popup_info", false);
      this.$router.push({
        name: "login",
        params: { loginUserSelected: false }
      });
    },
    checkFillAllInputs() {
      if (this.formData.first_name === "" || this.formData.last_name === "") {
        this.userCreateError = {
          description: "Toate campurile sunt obligatorii"
        };
      } else {
        this.addUserForCompany();
      }
    },
    showModalPopup(elementId, show) {
      if (show) {
        document.getElementById(elementId).style.visibility = "visible";
      } else {
        document.getElementById(elementId).style.visibility = "hidden";
      }
    },
    validatePassword() {
      this.validPassword = validator.validatePassword(
        this.newPassword,
        this.confirmPassword
      );
    }
  },
  mounted() {
    this.uuid = utils.getUrlParam("uuid");
    if (!sessionStorage.getItem("club_jsonFile")) {
      httpServiceCommon.commonsService
        .getConfigFile(localStorage.language, "club")
        .then(function (response) {
          return response;
        })
        .then((data) => {
          this.config = JSON.parse(
            sessionStorage.getItem("club_jsonFile")
          );
        });
    } else {
      this.config = JSON.parse(sessionStorage.getItem("club_jsonFile"));
    }
    this.getTokenForValidateCredentials();
  },
  computed: {
    confirmPasswordStyle() {
      return this.confirmPassword === ""
        ? ""
        : this.newPassword === this.confirmPassword
          ? ""
          : "outline-color: #ff0000a6;";
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css" />
<style scoped src="@/assets/styles/login.css" />

<style scoped>
.loginForm input[type="submit"].mandate-button {
  width: auto;
  height: 30px;
  padding: 0 30px;
}

.multiselect {
  border: 1px solid #d8d8d8;
  background: #f1f1f1 !important;
  height: 40px !important;


}

.multiselect__input {
  font-size: 15px !important;
}
.pointer {
  cursor: pointer !important;
}

body {
  background: #DEDEDE !important;
}
</style>
